import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ConfirmationService, FilterMetadata, SortEvent } from 'primeng/api';
import { DelegationBean } from '../model/DelegationBean';
import { UserBean } from '../model/UserBean';
import { DelegationService } from '../services/delegation-service';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ServiceType } from 'src/app/shared/Enums';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-edit-deleg-form',
  templateUrl: './edit-deleg-form.component.html',
  styleUrls: ['./edit-deleg-form.component.css']
})
export class EditDelegFormComponent {
  constructor(
    private confirmationService: ConfirmationService,
    private delegService: DelegationService,
    private authenticationService: AuthenticationService,
    private cdr: ChangeDetectorRef
  ) {}

  @Output() cancelEvent = new EventEmitter<boolean>();
  @Input() delegation : DelegationBean;
  @Input() canEdit: boolean;

  @ViewChild('dt') dt!: Table;
  @ViewChild('paginationEdit') paginationEdit!: NgbPagination;

  products: UserBean[];
  allProducts: UserBean[];
  allProductsStable: UserBean[];

  totalRecords: number;
  currentPage = 1;
  rowsPerPage = 15;
  currentSort: SortEvent;
  dataInitialized: boolean = false;

  delegation1 : DelegationBean;
  mySelection: string;
  x: UserBean[];
  originalLength: number;

  ngOnInit(): void {
    if(!this.delegService.organisations?.length) {
      let user = this.authenticationService.getCurrentUser();
      let cvr = user?.cvr;
      if (this.delegation1) {
        cvr = this.delegation1.user?.cvr;
      }
      this.delegService.getOrganisations().then(data =>{
        this.delegService.setOrganisation(data);
        data.forEach(i => {
          delete i.role;
          delete i.description;
          delete i.type;
        })
        //dont allow delegating to yourself
        this.products = data.filter(org => org.cvr !== cvr);
        this.initializeData(this.products);
      })
    } else {
      if (this.delegation1) {
        this.products = this.delegService.organisations.filter(org => org.cvr !== this.delegation1.user?.cvr);
      } else {
        this.products = this.delegService.organisations;
      }
      this.initializeData(this.products);
    }
  }


  initializeData(data: any) {
    this.allProducts = data;
    this.allProductsStable = data;
    this.totalRecords = data.length;
    if (this.showPagination) {
      const firstItemIndex = (this.currentPage - 1) * this.rowsPerPage;
      this.products = this.allProducts.slice(firstItemIndex, firstItemIndex + this.rowsPerPage);

    }
    else {
      this.products = data;
    }

    this.dataInitialized = true;
    this.cdr.detectChanges();
  }

  ngOnChanges() {
    this.originalLength= this.delegation?.delegeredeUser.length
    this.delegation1= JSON.parse(JSON.stringify(this.delegation));
  }

  ngAfterContentChecked(): void {
    if (this.dataInitialized && this.dt?.value) {
      this.dataInitialized = false;
      this.inputChange("", "");
    }
  }


  onRowSelect(event : any) {
    if(this.canEdit) {
      this.delegation1.delegeredeUser.push(event.data);
    }
  }

  isEditable() {
    if(this.authenticationService.canUserEdit()) {
      return this.delegation1.canEdit;
    } else {
      return false;
    }
  }

  onCancel() {
    if (
      JSON.stringify(this.delegation1.delegeredeUser) !== JSON.stringify(this.delegation.delegeredeUser)
    ) {
      this.confirmationService.confirm({
        message:
          'Du er ved at navigere væk fra en side med ændrede data uden at gemme først. Ønsker du at fortsætte?',
        header: 'Ændringer er ikke gemt',
        rejectLabel: 'Nej',
        acceptLabel: 'Ja',
        accept: () => {
          this.cancelEvent.emit(true);
        },
      });
    } else {
      this.cancelEvent.emit(true);
    }
  }

  closeScreen() {
    this.cancelEvent.emit(true); 
  }
  
  remove(fruit: any): void {
    const index = this.delegation1.delegeredeUser.indexOf(fruit);
    if (index >= 0) {
      this.delegation1.delegeredeUser.splice(index, 1);
    }
  }

  //'Bemærk at du er ved at delegere…',
  submit() {
    this.confirmationService.confirm({
      message:
        'Delegerede brugere kan få vist / opdatere rutningsregler, som kan ses / opdateres af din organisation',
      header: 'Vilkår for delegering',
      rejectLabel: 'Ja',
      acceptLabel: 'Nej',
      reject: () => {
        this.delegService.updateDelegation(this.delegation1).then( (data) => {
          this.cancelEvent.emit(true);
        });
      },
    });
  }

  getServiceTypeText(serviceType: any): string {
    if(serviceType === undefined){
      serviceType ='';
    }

    switch (serviceType) {
      case 'FILSERVICE':
        return ServiceType.FILSERVICE;
      case 'WEBSERVICE':
        return ServiceType.WEBSERVICE;
      default:
        return '';
    }
  }

  onPageChange(pageNumber: number) {
    this.currentPage = pageNumber;
    this.products = this.allProducts.slice((pageNumber - 1) * this.rowsPerPage,
      (pageNumber - 1) * this.rowsPerPage + this.rowsPerPage);
  }

  get showPagination(): any {
    return this.rowsPerPage && (this.rowsPerPage > 0) && (this.allProducts?.length > this.rowsPerPage);
  }

  customSort(event: SortEvent) {
    if (!this.currentSort) {
      this.currentSort = event;
    }

    let property = event.field as keyof UserBean;

    if (property) {

      this.allProducts.sort((data1: any, data2: any) => {
        let value1 = data1[property];
        let value2 = data2[property];
        let result = null;

        let newOrder = event.order ? event.order : 0;

        result = value1?.toString().localeCompare(value2?.toString());

        return (newOrder * result);
      })
    }

    if(this.allProducts?.length < this.rowsPerPage) {
      this.products = this.allProducts.slice(0, this.rowsPerPage);
    }

    if (this.currentSort.field !== event.field || this.currentSort.order !== event.order) {
      this.paginationEdit?.pageChange?.emit(1);
      if(this.paginationEdit) {
        this.paginationEdit.page = 1;
      }
      
      this.currentSort = event;
    }
    
    if(this.paginationEdit) {
      this.paginationEdit.page = 1;
    }
  }

  inputChange(inputValue: string, field: string) {
    if (this.allProducts) {
      let filters = Object.entries(this.dt.filters).map((e) => ({ [e[0]]: e[1] }));
      if (field && filters) {
        for (const filter of filters) {
          if (filter[field] != null) {
            this.dt.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          } else {
            this.dt.filters[field] = {
              value: inputValue,
              matchMode: "contains"
            }
          }
        }
      } else {
        this.dt.filters[field] = {
          value: inputValue,
          matchMode: "contains"
        }
      }

      filters = Object.entries(this.dt.filters).map((e) => ({ [e[0]]: e[1] }));

      this.allProducts = this.allProductsStable;

      for (const f of filters) {
        let property = Object.keys(f).at(0) as keyof UserBean;
        let filterMetadata = f[property] as FilterMetadata;
        if (filterMetadata.value) {
          this.allProducts = this.allProducts.filter(data => data[property]?.toString().toLowerCase().includes(filterMetadata.value.toLowerCase()));
        }
      }
      this.totalRecords = this.allProducts.length;
      if (this.allProducts?.length > 0) {
        this.paginationEdit?.pageChange?.emit(1);
        this.currentPage = 1;
        if(!this.paginationEdit) {
          this.onPageChange(1);
        } else {
          this.paginationEdit.page = 1;
        }
      }
    }

  }

}
